import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Select, Switch, Row, Col, Card, Collapse, message, Spin } from "antd";
import { setSubscriptionList } from "../../../Redux/AuthSlice";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { CALL_API } from "../../../Common/api";
import { ButtonFilled } from "../../../Reusablecomponents/UIButtons";
import { CaretRightOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

const { Option } = Select;
const { Panel } = Collapse;

const PageWrapper = styled.div`
  padding: 10px;
  margin-left: -20px;
`;

const Header = styled.div`
  .title {
    font-size: 14px;
    font-weight: 400;
    color: #5f6d8c;
  }
  .choose {
    font-size: 16px;
    font-weight: 500;
    line-height: 20.83px;
    padding: 5px 16px;
    display: flex;
    align-items: center;
    margin-left: auto;
  }
  .main_tenant_subscription {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
  }
  .main_tenant_subscriptioncompany {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .main_tenant_chooseall {
    display: flex;
    align-self: flex-end;
    gap: 15px;
  }
  @media (max-width: 480px) {
    .main_tenant_subscriptioncompany {
      flex-direction: column;
      align-items: flex-start;
    }
    .main_tenant_subscription {
      flex-direction: column;
    }
  }
`;

const StyledSelect = styled(Select)`
  .ant-select-selector {
    width: 370px !important;
    height: 36px !important;
    border-radius: 20px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: #e7e7ed;
  }
  .ant-select-selection-item {
    line-height: 36px;
  }
  @media (max-width: 480px) {
    .ant-select-selector {
      width: 270px !important;
    }
  }
`;

const TenantSubscription = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const subscriptionList = useSelector(
    (state) => state?.authTracking?.subscriptionList,
  );
  const roleList = useSelector((state) => state?.authTracking?.roleList);

  const [loading, setLoading] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [subscriptionDetails, setSubscriptionDetails] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedSections, setSelectedSections] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [permissions, setPermissions] = useState([]);
  const [changedSections, setChangedSections] = useState([]);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const saveAllowed = useMemo(
    () => hasPermission("SUBSCRIBE", "AATS"),
    [reduxPermissions],
  );
   const navigate = useNavigate();

    useEffect(() => {
      if (userInfo?.UID !== 2) {
        navigate("/Home");
      }
    }, [userInfo?.UID]);
  // const toggleSection = (secCode, checked) => {
  //   setSelectedSections(prev => {
  //     const next = checked
  //       ? [...prev, secCode]
  //       : prev.filter(code => code !== secCode);

  //     setSelectAll(next.length === totalSections);
  //     return next;
  //   });
  // };
  const toggleSection = (secCode, checked) => {
    setSelectedSections((prev) => {
      const next = checked
        ? [...prev, secCode]
        : prev.filter((code) => code !== secCode);

      // track changes only
      setChangedSections((changed) => {
        if (checked && !changed.includes(secCode)) {
          return [...changed, secCode];
        }
        if (!checked && changed.includes(secCode)) {
          return changed.filter((c) => c !== secCode);
        }
        return changed;
      });

      setSelectAll(next.length === totalSections);
      return next;
    });
  };

  // Fetch companies & permissions
  const fetchAllCompany = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("GET", "subscription/getallCompany");
      setCompanyList(data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllRoleAction = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", "role/roleAction", {
        MCID: userInfo?.MCID,
        ROLEId: userInfo?.ROLEID || 200,
      });
      setPermissions(data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [userInfo?.MCID, userInfo?.ROLEID]);

  // Fetch subscription data when company changes
  const fetchSubscriptionData = async (selectedCompany) => {
    if (!selectedCompany) return;
    setLoading(true);
    setIsDisabled(false);
    try {
      const { data } = await CALL_API(
        "GET",
        `subscription/get?McId=${selectedCompany}&limit=100&page=1`,
      );
      setSubscriptionDetails(data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const [menuData, setMenuData] = useState([]);
  const fetchSubscriptionsMenu = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `subscription/getById?McID=${userInfo?.MCID}`,
      );

      // Flatten to array of SECCODEs
      const subscriptionSecCodes =
        data?.map((sub) => sub.SECCODE?.trim()?.toUpperCase()) || [];

      // Update Redux + local state
      dispatch(setSubscriptionList(subscriptionSecCodes));
      setMenuData(subscriptionSecCodes);
    } catch (error) {
      console.error("[fetchSubscriptions] error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllCompany();
    fetchAllRoleAction();
  }, []);

  useEffect(() => {
    fetchSubscriptionData(selectedCompany);
  }, [selectedCompany]);

  const allSectionCodes = useMemo(
    () => permissions.flatMap((g) => g.Sections?.map((s) => s.secCode) || []),
    [permissions],
  );

  const totalSections = allSectionCodes.length;

  useEffect(() => {
    if (permissions?.length > 0 && subscriptionDetails.length > 0) {
      setSelectedSections(subscriptionDetails.map((item) => item.SECCODE));
      setSelectAll(
        allSectionCodes.length > 0 &&
          subscriptionDetails.length === allSectionCodes.length,
      );
    }
  }, [permissions, subscriptionDetails, allSectionCodes.length]);

  const isAllSelected = selectedSections.length === totalSections;

  const subscribedSet = useMemo(
    () => new Set(subscriptionDetails.map((item) => item.SECCODE)),
    [subscriptionDetails],
  );
  const handleSelectAll = (checked) => {
    setSelectAll(checked);
    setSelectedSections(checked ? [...allSectionCodes] : []);
  };

  const handleAction = async () => {
    try {
      setLoading(true);
      await CALL_API("POST", `subscription/add`, {
        McId: selectedCompany,
        Subscriptions: selectedSections.map((secCode) => ({
          SECCODE: secCode,
        })),
      });

      message.success("Subscription Added Successfully");
      fetchSubscriptionsMenu();
      setLoading(false);
      // window.location.reload();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (userInfo?.MCID) {
      fetchSubscriptionsMenu();
    }
  }, [userInfo?.MCID]);
  const loadingText = ["Loading", "Loading.", "Loading..", "Loading..."];
  const [dotIndex, setDotIndex] = useState(0);

  useEffect(() => {
    if (!loading) return;
    const interval = setInterval(() => {
      setDotIndex((i) => (i + 1) % loadingText.length);
    }, 500);
    return () => clearInterval(interval);
  }, [loading]);

  return (
    <PageWrapper>
      <Header>
        <div>
          <label>Select Company: </label>
          <StyledSelect
            showSearch
            optionFilterProp="label"
            filterOption={(input, option) =>
              option?.label?.toLowerCase().includes(input.toLowerCase())
            }
            options={companyList.map((item) => ({
              value: item.ID,
              label: item.NAME,
            }))}
            value={selectedCompany}
            onChange={setSelectedCompany}
            placeholder="Select a Company"
            allowClear
          />

          <ButtonFilled
            loading={loading}
            disabled={isDisabled || loading}
            onClick={handleAction}
          >
            {loading ? loadingText[dotIndex] : "Save"}
          </ButtonFilled>

          {selectedCompany && (
            <span>
              Choose All{" "}
              <Switch
                checked={isAllSelected}
                onChange={handleSelectAll}
              />
            </span>
          )}
        </div>
      </Header>

      {selectedCompany && (
        <Card style={{ backgroundColor: "transparent", border: "none" }}>
          <Collapse
            expandIconPosition="right"
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
            defaultActiveKey={permissions.map((_, idx) => idx.toString())}
          >
            {permissions.map((group, gIdx) => (
              <Panel key={gIdx} header={<span>{group.Group || "nnn"}</span>}>
                {group.Sections?.map((section, si) => {
                  const isChecked = selectedSections.includes(section.secCode);
                  return (
                    <div
                      key={si}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: isChecked ? "#c8eec8" : "#f1f1f1",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        marginBottom: "6px",
                      }}
                    >
                      <span>{section.section}</span>
                      <Switch
                        checked={selectedSections.includes(section.secCode)}
                        onChange={(chk) => toggleSection(section.secCode, chk)}
                      />
                    </div>
                  );
                })}
              </Panel>
            ))}
          </Collapse>
        </Card>
      )}
    </PageWrapper>
  );
};

export default TenantSubscription;
